module.exports = __webpack_public_path__ + "static/img/20005D_5_B_20220705_fit.a0e36a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20005D_5_B_20220705_fit.png
// module id = a40x
// module chunks = 0